import { Section } from "@/components/Section";
import { TagList } from "@/components/Tag";
import { skillGroups } from "@/data/skills";
import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";

export function Skills() {
  const { t } = useLocale();

  return (
    <Section id="skills" label={ui.skills} title={ui.skillsNote}>
      <div className="space-y-8">
        {skillGroups.map((group) => (
          <div key={group.name.en} className="grid gap-3 sm:grid-cols-[11rem_1fr] sm:gap-8">
            <h3 className="label pt-1 text-faint">{t(group.name)}</h3>
            <TagList items={group.items} label={t(group.name)} />
          </div>
        ))}
      </div>
    </Section>
  );
}
